var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCuratorIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 65,
    viewBox: "0 0 200 228",
    fill: "none",
    fillRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#curator_icon_svg__clip0_1081_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h200v228H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.905 133.933c6.093 13.76 11.204 16.905 18.674 16.905l-.394 2.162h-13.563c-8.452 0-13.563-4.521-18.084-14.939L66.915 87.15H51.387l-11.598 48.159c-1.769 8.256-.197 15.136 7.863 15.529l-.59 2.162H10.697l.59-2.162c6.29-.197 12.58-4.521 15.332-15.529l25.554-106.54c2.162-9.435.393-14.546-8.06-14.939l.59-2.359h41.28c23.981 0 42.458 12.974 42.458 34.203 0 23.981-25.947 41.476-51.107 41.476h-4.128l-.394 1.376 10.026 1.965 19.067 43.442zM68.881 13.83L52.173 83.612c4.324.393 12.58 1.376 19.263 1.376 24.965 0 42.263-18.478 42.263-40.1 0-17.495-10.615-31.058-32.237-31.058h-12.58z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.617 216.086c-28.7 0-45.014-25.554-45.211-55.825 0-45.407 36.365-90.815 77.644-90.815 14.743 0 20.443 7.863 27.913 7.863 2.948 0 5.7-.983 9.435-3.931l-2.948 51.5h-2.163c-.589-30.468-9.631-53.073-32.04-53.073-35.382 0-63.099 42.066-63.099 79.61.197 26.144 9.829 53.073 40.1 53.073 15.726 0 33.81-10.418 45.801-32.433l1.572.393c-11.204 24.374-33.613 43.638-57.004 43.638z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "curator_icon_svg__clip0_1081_168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h200v228H0z"
  })))));
}
export default SvgCuratorIcon;